
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","viewBox":"0 0 16 16","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.5 2H11V0.375C11 0.167906 10.8321 0 10.625 0H9.375C9.16791 0 9 0.167906 9 0.375V2H5V0.375C5 0.167906 4.83209 0 4.625 0H3.375C3.16791 0 3 0.167906 3 0.375V2H1.5C0.671562 2 0 2.67156 0 3.5V14.5C0 15.3284 0.671562 16 1.5 16H12.5C13.3284 16 14 15.3284 14 14.5V3.5C14 2.67156 13.3284 2 12.5 2ZM12.3125 14.5H1.6875C1.63777 14.5 1.59008 14.4802 1.55492 14.4451C1.51975 14.4099 1.5 14.3622 1.5 14.3125V5H12.5V14.3125C12.5 14.3622 12.4802 14.4099 12.4451 14.4451C12.4099 14.4802 12.3622 14.5 12.3125 14.5V14.5ZM10.661 8.22969L6.21381 12.6412C6.06678 12.7871 5.82934 12.7861 5.68347 12.6391L3.33687 10.2735C3.19103 10.1265 3.19197 9.88903 3.339 9.74316L4.04897 9.03891C4.196 8.89306 4.43344 8.894 4.57928 9.04106L5.95753 10.4305L9.42853 6.98731C9.57556 6.84147 9.813 6.84241 9.95887 6.98944L10.6631 7.69938C10.809 7.84641 10.808 8.08384 10.661 8.22969Z","transform":"translate(1)"}})])
          )
        }
      }
    